<ion-list mode="ios" lines="none" class="list-content">
  <ion-list mode="ios" lines="none" class="list-padlock"> </ion-list>
  <!-- ? Imagen Ticket -->
  <ion-item lines="none" mode="md" color="transparent">
    <ion-img
      [src]="'Icons.cell-tendero' | translate"
      class="img-cell-tendero"
    ></ion-img>
  </ion-item>

  <!-- * Descripción -->
  <ion-item
    lines="none"
    mode="md"
    color="transparent"
    class="ion-text-center item-descript"
  >
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="mpe-font-weight-600"
      [innerHTML]=" 'Labels.now-process-new-registration' | translate"
    >
    </ion-label>
  </ion-item>

  <!-- ? Boton de aceptar -->
  <ion-item lines="none" mode="md" color="transparent" class="item-button">
    <ion-button
      class="button-accept"
      size="default"
      mode="md"
      color="darkblue"
      (click)="onAccept()"
    >
      <ion-label mode="md" class="mpe-font-weight-600">
        {{ 'Buttons.go-to-record' | translate }}
      </ion-label>
    </ion-button>
  </ion-item>
</ion-list>
